<script>
import TablePage from '@/found/components/table_page';
import request from '@/found/utils/request';
import DetailModal from '../components/detail_table.vue';
import Form from '../../../../../mdm/views/terminal_info/form/form.vue';

export default {
  name: 'main-list',
  extends: TablePage,
  data() {
    return {
      formConfig: {},
      modalConfig: {
        title: '新增',
        visible: false,
        type: '',
      },
      searchFormData: {},
      isCalculateHeight: false,
    };
  },
  components: {
    Form,
    DetailModal,
  },
  methods: {
    /** @override 重写重置按钮 */
    beforeSearchEvent({ $event }) {
      this.$emit('newData', this.formData);
      if ($event.type === 'reset') {
        this.$emit('newData', {});
      }
      return true;
    },
    modalClick({ val, row }) {
      if (val.code === 'view') {
        this.formName = 'Form';
        this.modalConfig.title = '终端信息';
        this.modalConfig.width = '80%';
        this.formConfig.id = row.terminalId;
        this.formConfig.code = val.code;
        this.openDrawer();
      }
      if (val.code === 'scan_details') {
        this.formName = 'DetailModal';
        this.modalConfig.title = '扫码明细';
        this.modalConfig.width = '80%';
        this.formConfig.row = row;
        this.formConfig.code = val.code;
        this.propsObjInData = {
          scanParticipatorCode: row.scanParticipatorCode,
          scanSupplyUserName: row.scanSupplyUserName,
          companyCode: row.companyCode,
          createTimeYear: row.createTimeYear,
        };
        this.openDrawer();
      }
    },
  },
  created() {
    this.getConfigList('main-list');
  },
};
</script>
